import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=2d553058&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"
import style0 from "./Access.vue?vue&type=style&index=0&id=2d553058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d553058",
  null
  
)

export default component.exports